import { type LegacyStreamResponseInput } from '../legacy/_stream-response';

// Config-only projection, not an intent classifier. Never infer missing caller fields.
export type ConfigInput = Pick<
  LegacyStreamResponseInput,
  | 'generationMethod'
  | 'aiCommandText'
  | 'aiCommandId'
  | 'templateId'
  | 'voiceStyle'
  | 'customStyle'
  | 'brain'
  | 'dictationCleanupMode'
  | 'contentType'
>;

export function toConfigInput(input: ConfigInput): ConfigInput {
  return {
    generationMethod: input.generationMethod,
    aiCommandText: input.aiCommandText,
    aiCommandId: input.aiCommandId,
    templateId: input.templateId,
    voiceStyle: input.voiceStyle,
    customStyle: input.customStyle,
    brain: input.brain,
    dictationCleanupMode: input.dictationCleanupMode,
    contentType: input.contentType,
  };
}
